import { Star } from 'lucide-react';

import { checkInQuestions } from '../data/check-in-questions';

import { QuestionCard } from './question-card';

import { useFavoritesStore } from '@/stores/favorites-store';

export function FavoritesSection() {
  const favorites = useFavoritesStore((s) => s.favorites);

  if (favorites.size === 0) return null;

  const favoriteQuestions = checkInQuestions.filter((q) => favorites.has(q.id));

  return (
    <div className="space-y-3">
      <h2 className="flex items-center gap-2 text-lg font-semibold">
        <Star className="h-5 w-5 text-yellow-500" />
        Favorites
      </h2>
      <div className="space-y-2">
        {favoriteQuestions.map((q) => (
          <QuestionCard key={q.id} question={q} />
        ))}
      </div>
    </div>
  );
}
